import { Cpu, Heart } from "lucide-react";
import { cn } from "@/lib/utils";

export const PYBRICKS_URL = "https://pybricks.com";
export const SUPPORT_PYBRICKS_URL = "https://www.patreon.com/pybricks";

export const PoweredByPybricks = ({ className, testId = "powered-by-pybricks" }) => (
  <div className={cn("inline-flex flex-wrap items-center gap-x-3 gap-y-1.5", className)} data-testid={testId}>
    <a href={PYBRICKS_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1.5 text-sm font-semibold transition-colors hover:border-primary/50 hover:text-primary" data-testid={`${testId}-link`}>
      <Cpu className="h-4 w-4 text-primary" />Powered by Pybricks
    </a>
    <a href={SUPPORT_PYBRICKS_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground underline decoration-primary/40 underline-offset-4 transition-colors hover:text-primary" data-testid={`${testId}-support-link`}>
      <Heart className="h-3.5 w-3.5" />Support Pybricks
    </a>
  </div>
);
